import { Icons } from './Icons'
import { COMPANY } from '@/data/company'
import { CORSI_PAGE_ENABLED, CORSI_URL } from '@/data/mikrotik'

// Moduli e Contrattualistica rimandano alla sezione documenti della pagina Assistenza
// (ancora da realizzare).
const ASSISTENZA = '/assistenza'
const ASSISTENZA_DOCUMENTI = '/assistenza#documenti'

// Looking Glass: strumento di rete pubblico, ospitato su sottodominio dedicato.
const LOOKING_GLASS = 'https://lg.spadhausen.com/'

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src="/assets/logo-spadhausen-light.svg" alt="Spadhausen" width={190} height={34} />
            <p>Operatore internet indipendente a Ravenna dal {COMPANY.foundedYear}.</p>
            <p className="footer-addr">
              {COMPANY.address.street}, {COMPANY.address.postalCode} {COMPANY.address.locality} · {COMPANY.phone}
            </p>
            <div className="footer-social">
              {COMPANY.social.facebook && <a href={COMPANY.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Icons.fb style={{ width: 16, height: 16 }} /></a>}
              {COMPANY.social.linkedin && <a href={COMPANY.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><Icons.li style={{ width: 16, height: 16 }} /></a>}
              {COMPANY.social.youtube && <a href={COMPANY.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><Icons.yt style={{ width: 16, height: 16 }} /></a>}
            </div>
          </div>

          <div className="footer-col">
            <h4>Internet e telefono</h4>
            <ul>
              <li><a href="/offerte-casa">Fibra per la casa</a></li>
              <li><a href="/offerte-business">Internet per aziende</a></li>
              <li><a href="/mobile">Telefonia mobile</a></li>
              <li><a href="/voip">Telefono fisso VoIP</a></li>
              <li><a href="/centralino-virtuale">Centralino virtuale</a></li>
              <li><a href="/ip-pubblico">Indirizzo IP pubblico</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>MikroTik</h4>
            <ul>
              {CORSI_PAGE_ENABLED && <li><a href={CORSI_URL}>Corsi MikroTik certificati</a></li>}
              <li><a href="/consulenza-mikrotik">Consulenza MikroTik</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Azienda</h4>
            <ul>
              <li><a href="/chi-siamo">Chi siamo</a></li>
              <li><a href="/connessi-al-territorio">Connessi al territorio</a></li>
              <li><a href="/lavoriamo-insieme">Lavoriamo insieme</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/porta-un-amico">Porta un amico</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Supporto</h4>
            <ul>
              <li><a href="/verifica-copertura">Verifica copertura</a></li>
              <li><a href={ASSISTENZA}>Assistenza</a></li>
              <li><a href={ASSISTENZA_DOCUMENTI}>Moduli</a></li>
              <li><a href={ASSISTENZA_DOCUMENTI}>Contrattualistica</a></li>
              <li><a href={LOOKING_GLASS} target="_blank" rel="noopener noreferrer">Looking Glass</a></li>
              <li><a href="/parental-control">Parental Control</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <ul className="footer-legal">
            <li><a href="/carta-dei-servizi">Carta dei servizi</a></li>
            <li><a href="/trasparenza-tariffaria">Trasparenza tariffaria</a></li>
            <li><a href="/privacy">Informativa privacy</a></li>
            <li><a href="/conciliaweb">ConciliaWeb</a></li>
          </ul>
          <span className="footer-copy">© {new Date().getFullYear()} {COMPANY.legalName} · P.IVA {COMPANY.vatId}</span>
          <div className="footer-badges">
            {COMPANY.certifications.map((c) => (
              <span className="footer-badge" key={c}>{c}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
